
const Mock = require('mockjs');
const Random = Mock.Random;

const data = Mock.mock({
  "err": 0,
  "msg": "ok",
  "ret": {
    "list": [
      {
        "id": "23",
        "order_no": "YS117760647613583",
        "create_time": "2020-11-25 15:08:34",
        "payment_time": "2020-11-25 13:31:35",
        "product_price": 1,
        "price": 1,
        "state": "NEW",
        "product_id": "1",
        "paied": 0,
        "payment_method": "2",
        "product_name": "dddddd",
        "img": "https://yingshi-1254383113.file.myqcloud.com/49938751bf9a921f2fc3c8f3c6468972.png",
        "left": 113898
      },
      {
        "id": "22",
        "order_no": "YS53988967243332",
        "create_time": "2020-11-25 13:31:35",
        "payment_time": "2020-11-25 13:31:35",
        "product_price": 1,
        "price": 1,
        "state": "DEAL",
        "product_id": "1",
        "paied": 100,
        "payment_method": "2",
        "product_name": "ddd3333ddd",
        "img": "https://yingshi-1254383113.file.myqcloud.com/49938751bf9a921f2fc3c8f3c6468972.png",
        "left": 108079
      }
    ],
    "total": 5,
    "isStudent": 0
  }
});

module.exports = data;